var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFunction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34.334,
    viewBox: "0 0 34 34.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7cc7bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61779c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_job_role_2867276",
    "data-name": "noun_job role_2867276",
    transform: "translate(0 0.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7998",
    "data-name": "Rectangle 7998",
    width: 34,
    height: 34,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16782",
    "data-name": "Path 16782",
    d: "M41.456,8.228c0,3.442-2.786,7.586-6.228,7.586S29,11.67,29,8.228a6.228,6.228,0,0,1,12.456,0Z",
    transform: "translate(-19.346 -1.334)",
    fill: "none",
    stroke: "#EB1700",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16783",
    "data-name": "Path 16783",
    d: "M24.473,57.589A6.345,6.345,0,0,1,34.31,52.3a14.052,14.052,0,0,0-10.3-5.056c-5.076,0-11.824,4.118-11.824,9.194s2.8,4.63,11.824,4.63h1.5a6.325,6.325,0,0,1-1.039-3.475Z",
    transform: "translate(-8.132 -31.515)",
    fill: "none",
    stroke: "#EB1700",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16784",
    "data-name": "Path 16784",
    d: "M55.018,71.756a6.548,6.548,0,1,1,6.548-6.548A6.548,6.548,0,0,1,55.018,71.756Zm0-12.683a6.138,6.138,0,1,0,6.138,6.135A6.138,6.138,0,0,0,55.018,59.073Z",
    transform: "translate(-32.335 -39.133)",
    stroke: "#EB1700",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16785",
    "data-name": "Path 16785",
    d: "M64.394,70.932H62.88v-.666A.253.253,0,0,0,62.627,70h-2.9a.253.253,0,0,0-.253.253v.666H57.956a.26.26,0,0,0-.256.256v4.114a.256.256,0,0,0,.256.253h6.438a.256.256,0,0,0,.256-.253v-4.1a.26.26,0,0,0-.256-.256ZM59.964,70.5h2.423v.436H59.964Zm4.194,4.554H58.193v-2.12H60.35v.529a.253.253,0,0,0,.253.253h1.145A.253.253,0,0,0,62,73.459v-.529h2.157Zm-3.329-1.831v-.29h.666v.29Zm3.329-.782H58.193v-1h5.965Z",
    transform: "translate(-38.493 -46.698)",
    stroke: "#EB1700",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunction);
export default __webpack_public_path__ + "static/media/function.4237046bbed2344ae1bd5ffe658de295.svg";
export { ForwardRef as ReactComponent };